import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';

/**
 * Sets a Configuration Profile as default or not
 * @param id Set ID of the Configuration Profile
 * @param isDefault Whether the Configuration Profile will be set as default
 */
export function putConfigurationProfilesDefault(
  this: unknown,
  id: number,
  isDefault: boolean
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment
          .resolve(this)
          .configurationProfilesIdDefaultUrl(id)}/${isDefault.toString()}`,
        {
          method: 'PUT',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.boolean(),
        message: z.string(),
      })
    )
  );
}
